import { cn } from "@aisquare/ui";

/**
 * The AISquare mark.
 *
 * Geometry lifted verbatim from the brand asset — the six facet polygons of
 * `public/brand/aisquare-blue-horizontal.svg` in `aisquare-studio-unified`,
 * with the "AISQUARE" wordmark letterforms (the eight sibling `<path>`s)
 * dropped and the viewBox cropped to the mark. Nothing here is redrawn: if the
 * brand asset changes, re-extract rather than nudging these points.
 *
 * Painted with `currentColor` rather than the asset's baked `#0a2540`, which
 * reproduces the official treatment exactly. Unified ships a blue variant for
 * light surfaces and a white one for dark, and those two files carry identical
 * geometry differing only in fill — so rendering `currentColor` under
 * `text-foreground` resolves to navy in light and white in dark, covering both
 * with one copy, and it stays correct if a consumer retints the token.
 *
 * Decorative (`aria-hidden`): every placement sits beside the package name
 * inside an already-labelled link, so giving the glyph its own accessible name
 * would just announce the brand twice.
 */
export function AISquareMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 213.32 246.35"
      fill="currentColor"
      aria-hidden="true"
      className={cn("block", className)}
    >
      <g>
      <polygon points="128.29 233.86 106.66 246.35 85.21 233.96 77.63 229.59 58.37 218.47 56.02 217.11 56 217.11 50.79 214.08 48.42 212.71 29.19 201.62 29.19 112.14 50.79 99.66 50.79 189.14 58.37 193.51 70.05 200.23 77.63 204.63 99.26 217.11 106.84 221.48 128.29 233.86" />
      <polygon points="213.32 160 213.32 184.76 191.71 197.25 184.13 201.62 165.06 212.64 162.53 214.08 154.95 218.47 135.87 229.49 114.42 217.11 106.84 212.71 85.21 200.23 77.63 195.86 58.37 184.74 58.37 159.8 99.23 183.4 106.81 187.77 128.44 200.25 136.02 204.63 143.6 200.25 154.95 193.71 162.53 189.31 184.13 176.86 191.71 172.46 213.32 160" />
      <polygon points="213.32 61.58 213.32 151.23 191.71 163.72 184.13 168.09 162.53 180.57 154.95 184.94 136.02 195.88 114.39 183.4 154.95 159.98 162.53 155.6 184.13 143.12 191.71 138.75 191.71 49.1 213.32 61.58" />
      <polygon points="184.13 44.73 184.13 134.38 162.53 146.84 162.53 57.16 154.95 52.79 143.48 46.17 135.9 41.77 114.27 29.29 106.71 24.91 106.69 24.91 85.08 12.46 106.66 0 128.27 12.48 135.82 16.83 135.85 16.83 154.95 27.87 157.45 29.31 162.53 32.27 165.03 33.71 184.13 44.73" />
      <polygon points="154.95 61.53 154.95 86.49 114.29 63.02 114.27 63.02 106.69 58.62 85.08 46.14 77.5 41.77 69.92 46.17 58.37 52.81 50.79 57.21 29.19 69.67 21.6 74.04 0 86.52 0 61.58 21.6 49.1 29.19 44.73 48.31 33.68 50.79 32.27 50.79 32.24 55.89 29.31 58.37 27.87 77.5 16.83 77.52 16.83 99.13 29.29 106.69 33.66 128.32 46.14 135.9 50.54 154.95 61.53" />
      <polygon points="99.1 63.02 58.37 86.52 50.79 90.89 29.19 103.37 21.61 107.75 21.61 197.22 0 184.76 0 95.26 21.61 82.81 29.19 78.41 50.79 65.95 58.37 61.55 77.47 50.54 99.1 63.02" />
      </g>
    </svg>
  );
}
